var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"app-body"},[_c('StoreLogTable',{attrs:{"query-type":"receiver","hide-columns":['receiverName','price','boxReceiptCode','totalReceiveCount'],"hide-buttons":['receive','price','cancel'],"hide-query":['receiverName','status','orderCode','boxReceiptCode'],"default-query-params":{status:20}}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }